// extracted by mini-css-extract-plugin
export default {"ola_Container":"Ola_ola_Container__Qs5PQ","ola_Wrapper":"Ola_ola_Wrapper__xEV8l","ola_Link":"Ola_ola_Link__BzqKo"};